import { useQuery } from "@tanstack/react-query";
import { authClient } from "../../lib/auth-client";
import { isNative } from "../../lib/platform";
import { getPaywallPackages } from "../../lib/revenueCat";

/**
 * Native only: the monthly and annual packages of RevenueCat's current
 * offering, with localized store prices and this user's trial eligibility.
 * Never runs on web, where the paywall falls back to its design-time figures.
 */
export const usePaywallPackages = () => {
  const { data: session } = authClient.useSession();
  const userId = session?.user?.id;

  return useQuery({
    queryKey: ["paywallPackages", userId],
    queryFn: () => getPaywallPackages(userId!),
    enabled: isNative() && !!userId,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
};
